class ProductGridZoom extends HTMLElement {
  connectedCallback() {
    const targetSelector = this.getAttribute("target");
    this.grid = document.querySelector(targetSelector);
    this.slider = this.querySelector('input[type="range"]');
    this.decreaseBtn = this.querySelector(".grid-zoom__decrease");
    this.increaseBtn = this.querySelector(".grid-zoom__increase");

    this.storageKey = "product-grid-size";

    this.mobileQuery = window.matchMedia("(max-width: 768px)");

    this.setupSizes();
    this.restoreSize();
    this.attachEvents();

    this.mobileQuery.addEventListener("change", () => {
      this.setupSizes();
      this.restoreSize();
    });
  }

  setupSizes() {
    if (this.mobileQuery.matches) {
      this.sizes = ["default", "large"];
      this.slider.max = 1;
    } else {
      this.sizes = ["small", "default", "large"];
      this.slider.max = 2;
    }
  }

  restoreSize() {
    const savedSize = localStorage.getItem(this.storageKey);
    let size = savedSize || this.grid?.dataset.size || "default";

    // prevent "small" on mobile
    if (!this.sizes.includes(size)) {
      size = "default";
    }

    this.setIndex(this.sizes.indexOf(size), { persist: false });
  }

  // Central place that applies a size index to the grid, slider, storage, and button states
  setIndex(index, { persist = true } = {}) {
    if (index < 0 || index >= this.sizes.length) return;

    const size = this.sizes[index];

    if (this.grid) {
      this.grid.dataset.size = size;
    }

    this.slider.value = index;

    if (persist) {
      localStorage.setItem(this.storageKey, size);
    }

    this.updateButtonStates(index);
  }

  updateButtonStates(index) {
    if (this.decreaseBtn) {
      this.decreaseBtn.disabled = index <= 0;
    }
    if (this.increaseBtn) {
      this.increaseBtn.disabled = index >= this.sizes.length - 1;
    }
  }

  attachEvents() {
    this.slider?.addEventListener("input", () => {
      this.setIndex(Number(this.slider.value));
    });

    this.decreaseBtn?.addEventListener("click", () => {
      this.setIndex(Number(this.slider.value) - 1);
    });

    this.increaseBtn?.addEventListener("click", () => {
      this.setIndex(Number(this.slider.value) + 1);
    });
  }
}

customElements.define("product-grid-zoom", ProductGridZoom);